<unit>{{'¥' | lang}}/{{name | lang}}</unit>
